"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconProductListing = function IconProductListing(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M13 2v9h9V2zm7 7h-5V4h5zM2 22h9v-9H2zm2-7h5v5H4zm18 7h-9v-9h9zm-2-7h-5v5h5zM2.72 6.332H2v1.092h.9c.492 1.692 1.92 2.664 3.624 2.664.984 0 1.788-.252 2.496-.756l-.876-1.5c-.516.36-.876.516-1.572.516-.744 0-1.308-.312-1.62-.924h1.38l.624-1.092H4.688c-.012-.096-.012-.192-.012-.288l.012-.288h2.604l.624-1.092H4.952c.312-.612.876-.924 1.62-.924.696 0 1.056.156 1.572.516l.876-1.5C8.312 2.252 7.508 2 6.524 2 4.82 2 3.392 2.972 2.9 4.664H2v1.092h.72c-.012.096-.012.192-.012.288z",
    clipRule: "evenodd"
  })));
};

export { IconProductListing, IconProductListing as default };
